<mat-dialog class="lg-notifications-dialog lg-scrollbar">
    <div id="nubbin-top-right"></div>
    <div>
        <mat-dialog-title class="modal-title">
            <span>Notifications</span>
        </mat-dialog-title>
        <div>
            <mat-dialog-content class="modal-content">
                <ng-container *ngIf="dialogNotifications?.length">
                    <div
                        class="notification-body"
                        *ngFor="let notification of dialogNotifications"
                        [ngClass]="{ read: notification.isRead }"
                    >
                        <div class="notification-content" (click)="alertClickHandler(notification)">
                            <div class="notification-text">
                                <span>{{ notification.alertDescription }}</span>
                            </div>
                            <div class="notification-date">
                                <span>
                                    {{ notification.dateOffset | number: '1.0-0' }}
                                    {{ notification.offsetType }} ago
                                </span>
                            </div>
                        </div>
                    </div>
                </ng-container>

                <ng-container *ngIf="!dialogNotifications?.length">
                    <div class="notification-body">
                        <p class="no-notifications-text">You don't have any notifications.</p>
                    </div>
                </ng-container>
            </mat-dialog-content>
        </div>
        <div class="notifications-actions-area">
            <a
                [routerLink]="['/settings/notifications']"
                class="view-all-link"
                (click)="onNoClick()"
            >
                View All Notifications
            </a>
        </div>
    </div>
</mat-dialog>
